<template>
  <div class="col-sm-12 routa-light contact">
    <h1 class="title blue">{{ $t('contact.title') }}</h1>
      <b-row class="reference-container" align-h="center">
      <div class="col-sm-4">
          <div class="contact-cont">
              <span class="contact-name orange">Kaisa Rautiainen</span>
              <span class="contact-text">{{ $t('contact.finland')}}</span>
              <span class="contact-text">info@routasystems.com</span>
              <span class="contact-text">+358 50 372 8571</span>
          </div>
      </div>
      <div class="col-sm-4">
          <div class="contact-cont">
              <span class="contact-name orange">Timo Salminen</span>
              <span class="contact-text">{{ $t('contact.finland')}}</span>
              <span class="contact-text">timo.salminen@sitowise.com</span>
              <span class="contact-text">+358 44 427 9603 </span>
          </div>
      </div>
  </b-row>
  </div>
</template>

<script>
export default {
  name: 'MinContact',
  data: function () {
    return {
      showSuccess: false,
      showError: false,
      message: '',
      email: '',
      name: '',
      phone: ''
    }
  },
  methods: {
  }
}
</script>

